import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  Context,
  editSubClassPath,
  editSubClassStudentPath,
  fetchSubClasses,
  fetchTeachers,
  newSubClassPath,
  deleteSubClass,
  clearSuccessMessage,
  DELETE_SUB_CLASS_SUCCESS_MESSAGE,
} from "../../../managerStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import Toast from "../../../molecules/Toast";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import SubClassList from "../../../templates/manager/SubClassList";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const history = useHistory();

  React.useEffect(() => {
    dispatch(fetchSubClasses());
    dispatch(fetchTeachers());
  }, [dispatch]);

  React.useEffect(() => {
    if (state.success_message === DELETE_SUB_CLASS_SUCCESS_MESSAGE) {
      Toast.success(state.success_message);
      dispatch(clearSuccessMessage());
    }
  }, [dispatch, state.success_message]);

  const toBuildNewSubClass = React.useCallback(() => {
    history.push(newSubClassPath);
  }, [history]);

  const toEditSubClass = React.useCallback(
    (id: number) => {
      history.push(`${editSubClassPath}/${id}`);
    },
    [history],
  );

  const toEditSubClassStudent = React.useCallback(
    (id: number) => {
      history.push(`${editSubClassStudentPath}/${id}`);
    },
    [history],
  );

  const deleteSubClassFunc = React.useCallback(
    (id: number) => {
      dispatch(peep(deleteSubClass(id)));
    },
    [dispatch, peep],
  );

  return (
    <div>
      <Breadcrumb currentTitle={titles.subClasses} />
      <SubClassList
        calling={calling}
        title={titles.subClasses}
        subClasses={state.sub_classes}
        teachers={state.teachers}
        toBuildNewSubClass={toBuildNewSubClass}
        toEditSubClass={toEditSubClass}
        toEditSubClassStudent={toEditSubClassStudent}
        deleteSubClass={deleteSubClassFunc}
      />
    </div>
  );
};
